import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const ModalContent = styled('div')`
  width: 750px;
  max-width: 80vw;
  color: ${theme.colors.neutral.high};
  .MuiFormControl-root {
    margin-bottom: ${theme.spacing.xm};
  }
`
export const ModalInfo = styled('div')`
  margin-bottom: ${theme.spacing.lg};
`

export const TableLabel = styled('div')`
  font-family: ${theme.typography.family.bold};
  font-size: ${theme.typography.sizes.xs};
  font-weight: ${theme.typography.weight.lg};
`

export const WrapTableStyled = styled.div`
  height: 30vh;
  overflow: scroll;

  div {
    overflow-x: unset;
  }

  thead th,
  tbody td {
    border: ${theme.shapes.borderWidth.none};
  }

  .MuiTableCell-head {
    font-size: ${theme.typography.sizes.xs};
    font-family: ${theme.typography.family.primary};
    font-weight: ${theme.typography.weight.lg};
    line-height: normal;
    background-color: ${theme.colors.neutral.white};
    padding: 0 ${theme.spacing.xm};
  }

  tbody {
    tr {
      padding: ${theme.spacing.xm} ${theme.spacing.xm};

      .MuiTableCell-body {
        font-family: ${theme.typography.family.primary};
        font-size: ${theme.typography.sizes.sm};
        font-weight: ${theme.typography.weight.sm};
        line-height: normal;
      }
    }
  }

  .MuiSvgIcon-root {
    fill: ${theme.colors.neutral.light};
    font-size: ${theme.icon.size.x.medium};
  }

  input.MuiInputBase-input {
    background: ${theme.colors.neutral.white};
    text-align: center;
    font-size: ${theme.typography.sizes.sm};
    padding: 0 ${theme.spacing.xs};

    @media only screen and (max-width: ${theme.breakpoints.sm}px) {
      font-size: ${theme.typography.sizes.xs};
    }
  }

  fieldset {
    border-color: ${theme.colors.neutral.light};
  }
`

export const WrapDesktopTableStyled = styled.div`
  height: 320px;
  overflow-x: auto;
  overflow-y: scroll;
  margin-bottom: ${theme.spacing.xm};

  .MuiFormControl-root {
    margin-bottom: ${theme.spacing.xm};
  }
  ::-webkit-scrollbar {
    width: ${theme.spacing.sm};
  }

  ::-webkit-scrollbar-track {
    background: ${theme.colors.neutral.clear};
    border-radius: ${theme.shapes.borderRadius.md};
  }

  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.neutral.light};
    border-radius: ${theme.shapes.borderRadius.md};
    border: none;
  }

  display: flex;
  width: 100%;
  table,
  thead,
  tbody {
    width: 100%;
  }
  thead th,
  tbody td {
    white-space: nowrap;
  }
  tbody td {
    text-align: left;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  thead th.checkbox-column,
  tbody td.checkbox-column {
    display: table-cell;
    width: 44px;
    padding: 0 0 0 ${theme.spacing.sm};
  }

  thead th.cd_clie,
  tbody td.cd_clie {
    width: 68px;
    text-align: center;
  }
  thead th.nm_clie,
  tbody td.nm_clie {
    width: 86px;
    text-align: center;
  }

  thead {
    border-bottom: 1px solid ${theme.colors.neutral.lighthover};
    tr th {
      padding-bottom: ${theme.spacing.xs} !important;
    }
  }

  @media only screen and (max-width: ${theme.breakpoints.md}px) {
    thead th.ds_matr,
    tbody td.ds_matr {
      max-width: 95%;
      width: 140px;
    }
  }
`
